<div class="iframe-container">
  <iframe
    [src]="iframeUrl"
    width="100%"
    height="600px"
    frameborder="0"
  ></iframe>
</div>
